import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import logoBright from '../../assets/img/illustrations/brightLogo.png';
import vericastLogo from '../../assets/img/logos/vericastlogo.png';
import vericastLogoRetail from '../../assets/img/logos/vericastlogoRETAILPORTALa.png'
import viamediaLogoSandBox from '../../assets/img/logos/viaMEDIAlogoSANDBOX.png'
import viamediaLogo from '../../assets/img/logos/viaMEDIAlogo01.png'
import nCountrLogo from '../../assets/img/logos/NCOUNTR_LOGO.png'
import screenverse from '../../assets/img/logos/screenverse.png'
import adminLOGO from '../../assets/img/logos/adminLOGOa.png'
import screenverseDarkmode from '../../assets/img/logos/SVdashlogoBIGdark.png'
import AppContext from '../../context/Context';
import SpectrioLight from '../../assets/img/logos/SPECTRIO_WHITE_BG.png'
import SpectrioDark from '../../assets/img/logos/SPECTRIO_DARK_BG.png'
import PerpetualBlue from '../../assets/img/logos/screenverse.png';
import PerpetualWhite from '../../assets/img/logos/SVdashlogoBIGdark.png';



const Logo = ({ at, width, className, ...rest }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const { isDark } = useContext(AppContext);


  const getLogoSrc = () => {
    if ([1].includes(user?.role) && [97].includes(user?.client_id)) {
      return isDark ? screenverseDarkmode : screenverse;
    }
    if ([1].includes(user?.role) && [90].includes(user?.client_id)) {
      return isDark ? SpectrioDark : SpectrioLight;
    }
    if ([1].includes(user?.role) && [87].includes(user?.client_id)) {
      return vericastLogoRetail;
    }
    if ([957, 953, 964, 963, 962, 993].includes(user?.user_id)) {
      return vericastLogo;
    }
    if ([1011, 1013, 1014].includes(user?.user_id)) {
      return viamediaLogoSandBox;
    }
    if ([1043].includes(user?.user_id)) {
      return viamediaLogo;
    }
    if ([1126].includes(user?.user_id)) {
      return nCountrLogo;
    }
    if ([1196, 1052].includes(user?.user_id)) {
      return isDark ? PerpetualWhite : PerpetualBlue;
    }
    // Check for "Hide Logo" flag from Client settings (supports direct Client User or Mapped User)
    const shouldHideClientLogo = user?.client_hide_logo;

    if (!shouldHideClientLogo) {
      // Client Logo is NOT hidden - Try to show it

      // 1. Determine the correct logo source (Direct or Mapped)
      const clientLogo = user?.client_logo;
      const clientDarkLogo = user?.client_dark_logo;

      // 2. Return appropriate logo based on Dark Mode
      if (isDark && (clientDarkLogo || clientLogo)) {
        return clientDarkLogo || clientLogo;
      }
      if (!isDark && clientLogo) {
        return clientLogo;
      }
    }
    // If shouldHideClientLogo is true, OR if no client logo found above,
    // logic falls through to the return statement below (Tenant Logo / Default).

    return isDark && user?.dark_logo
      ? user.dark_logo
      : !isDark && user?.white_logo
        ? user.white_logo
        : isDark
      ? PerpetualWhite
      : PerpetualBlue;
  };

  const getLogoWidth = () => {
    const shouldHideClientLogo = user?.client_hide_logo;
    if (!shouldHideClientLogo) {
      const clientWidth = user?.client_logo_width;
      if (clientWidth) return clientWidth;
    }
    if (user?.logo_width) {
      return user.logo_width;
    }
    if (([1, 10].includes(user?.role) && [97, 90].includes(user?.client_id))) {
      return 150;
    }
    if (([1].includes(user?.role) && [87].includes(user?.client_id)) || [1011, 1013, 1014].includes(user?.user_id)) {
      return 220;
    }
    if ([1043].includes(user?.user_id) || ([26].includes(user?.role) && [1196].includes(user?.user_id))) {
      return 150;
    }
    return 210;
  };

  const getLogoHeight = () => {
    const shouldHideClientLogo = user?.client_hide_logo;
    if (!shouldHideClientLogo) {
      const clientHeight = user?.client_logo_height;
      if (clientHeight) return clientHeight;
    }
    if (user?.logo_height) {
      return user.logo_height;
    }
    if (user?.dark_logo || user?.white_logo) {
      return 70;
    }
    return 30;
  }

  const logoContent = (
    <div
      className={classNames(
        'd-flex',
        {
          'align-items-center py-3': at === 'navbar-vertical',
          'align-items-center': at === 'navbar-top',
          'flex-center font-weight-extra-bold fs-5 mb-4': at === 'auth'
        },
        className
      )}
    >
      <img
        src={getLogoSrc()}
        alt="Logo"
        width={getLogoWidth()}
        height={getLogoHeight()}
      />
    </div>
  );

  if (at === 'auth') {
    return logoContent;
  }

  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      onClick={(e) => {
        if (user?.role === 30) {
          e.preventDefault();
        }
      }}
      {...rest}
    >
      {logoContent}
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
